import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrRiskLevelLadderComponent } from './pr-risk-level-ladder.component';

@NgModule({
  declarations: [PrRiskLevelLadderComponent],
  imports: [CommonModule],
  exports: [PrRiskLevelLadderComponent],
})
export class PrRiskLevelLadderModule {}
